import React from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import ProfileDetail from './contract-profile'
import CardCustom from '../../custom/card-custom'
import NavTitle from '../../nav-title'
import { BsChevronLeft } from 'react-icons/bs'
import BtnBack from '../../btn-back'
import { EMP_CONTRACT_NEW_EMP } from '../../../router/routes'

export default function IndexDetailContact() {
  let [searchParams, setSearchParams] = useSearchParams()
  const searchMulti = searchParams.get('searchMulti')

  return (
    <>
      <NavTitle>
        <BtnBack
          to={`${EMP_CONTRACT_NEW_EMP}?searchMulti=${searchMulti}`}
          className="text-muted"
        />
      </NavTitle>
      <CardCustom>
        <div className="d-flex ">
          <div
            className="ps-3 overflow-auto "
            style={{ minWidth: '280px', maxWidth: '280px', height: '86vh' }}
          >
            <ProfileDetail />
          </div>

          <div
            className="pe-3 ps-3  overflow-auto mt-3 bg-white"
            style={{ width: '100%', height: '86vh' }}
          >
            <Outlet />
          </div>
        </div>
      </CardCustom>
    </>
  )
}
